var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c("PermissionSimplePage", {
        attrs: { permission: _vm.hasAddPermission }
      }),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.hasAddPermission,
              expression: "hasAddPermission"
            }
          ]
        },
        [
          _c("div", { staticClass: "make-title" }, [
            _vm._v(_vm._s(_vm.$t("route.systemConfig")))
          ]),
          _vm._v(" "),
          _c(
            "el-form",
            {
              ref: "dataForm",
              staticStyle: { width: "400px", "margin-left": "20px" },
              attrs: {
                rules: _vm.rules,
                model: _vm.templateTemp,
                "label-position": "left",
                "label-width": "150px"
              }
            },
            [
              _c(
                "el-form-item",
                {
                  attrs: { label: _vm.$t("SMS.systemName"), prop: "systemName" }
                },
                [
                  _c("el-input", {
                    staticStyle: { width: "400px" },
                    model: {
                      value: _vm.templateTemp.systemName,
                      callback: function($$v) {
                        _vm.$set(_vm.templateTemp, "systemName", $$v)
                      },
                      expression: "templateTemp.systemName"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("SMS.smsDomainAddress"),
                    prop: "systemUrl"
                  }
                },
                [
                  _c("el-input", {
                    staticStyle: { width: "400px" },
                    model: {
                      value: _vm.templateTemp.systemUrl,
                      callback: function($$v) {
                        _vm.$set(_vm.templateTemp, "systemUrl", $$v)
                      },
                      expression: "templateTemp.systemUrl"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("SMS.remark"), prop: "remark" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "400px" },
                    model: {
                      value: _vm.templateTemp.remark,
                      callback: function($$v) {
                        _vm.$set(_vm.templateTemp, "remark", $$v)
                      },
                      expression: "templateTemp.remark"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "upload-container" }, [
            _c("div", { staticClass: "label" }, [
              _c("div", { staticClass: "upload-button-special" }, [
                _vm._v(_vm._s(_vm.$t("SMS.platformLOGO")))
              ])
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "input" },
              [
                _c(
                  "el-upload",
                  {
                    ref: "uploadLogo",
                    staticClass: "upload-demo",
                    attrs: {
                      drag: "",
                      limit: 1,
                      accept: "image/jpeg,image/png",
                      action: "#",
                      "auto-upload": false
                    }
                  },
                  [
                    _c("i", { staticClass: "el-icon-upload" }),
                    _vm._v(" "),
                    _c("div", { staticClass: "el-upload__text" }, [
                      _vm._v(_vm._s(_vm.$t("message.message60"))),
                      _c("em", [_vm._v(_vm._s(_vm.$t("message.message61")))])
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "el-upload__tip",
                        attrs: { slot: "tip" },
                        slot: "tip"
                      },
                      [_vm._v(_vm._s(_vm.$t("message.message62")))]
                    )
                  ]
                )
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("br"),
          _vm._v(" "),
          _c("div", { staticClass: "upload-container" }, [
            _c("div", { staticClass: "label" }, [
              _c("div", { staticClass: "upload-button-special" }, [
                _vm._v(_vm._s(_vm.$t("SMS.platformBackgroundImage")))
              ])
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "input" },
              [
                _c(
                  "el-upload",
                  {
                    ref: "uploadBgImage",
                    staticClass: "upload-demo",
                    attrs: {
                      drag: "",
                      limit: 1,
                      accept: "image/jpeg,image/png",
                      action: "#",
                      "auto-upload": false
                    }
                  },
                  [
                    _c("i", { staticClass: "el-icon-upload" }),
                    _vm._v(" "),
                    _c("div", { staticClass: "el-upload__text" }, [
                      _vm._v(_vm._s(_vm.$t("message.message60"))),
                      _c("em", [_vm._v(_vm._s(_vm.$t("message.message61")))])
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "el-upload__tip",
                        attrs: { slot: "tip" },
                        slot: "tip"
                      },
                      [_vm._v(_vm._s(_vm.$t("message.message62")))]
                    )
                  ]
                )
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "uniform-button",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function($event) {
                      return _vm.doResetTemp()
                    }
                  }
                },
                [
                  _vm._v(
                    "\n        " + _vm._s(_vm.$t("common.reset")) + "\n      "
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function($event) {
                      return _vm.uploadSystemConfig()
                    }
                  }
                },
                [
                  _vm._v(
                    "\n        " + _vm._s(_vm.$t("common.confirm")) + "\n      "
                  )
                ]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }